import { components } from '@kurtosys/ksys-app-components';

import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent.js';

const Button = components.base.Button.Button;

export default InjectedStyledComponent(Button, 'questionWizard', ['finishButton']);
